import { useState } from 'react'
import { useChamada } from './chamada.tsx'
import { Botao, BotoesDeMidia, Foto, MenusDeMidia, type Menu } from './ReuniaoDaSala.tsx'
import './chamada.css'

/**
 * A chamada vista do tabuleiro (SPEC-20261010-1557, SPEC-20261010-1715): quem
 * entra numa sala fica olhando o escritório e conversando, com microfone,
 * câmera e tela aqui embaixo. A sala da chamada (nome, quantos estão e as
 * fotos) é o botão que abre a reunião: dá para abrir a qualquer hora, com ou
 * sem câmera.
 */
export function BarraDaChamada({ cor, onAbrirReuniao }: { cor: string; onAbrirReuniao: () => void }) {
  const ch = useChamada()
  const [menu, setMenu] = useState<Menu>(null)
  if (!ch?.sala) return null
  const { quadros, sala, quemApresenta } = ch
  const novidade = quemApresenta ? (quemApresenta.nome === 'Você' ? 'Você está apresentando' : `${quemApresenta.nome} está apresentando`) : null
  return (
    <div className="chm-barra" role="region" aria-label={`Chamada em ${sala.nome}`}>
      <button type="button" className={`chm-barra-sala${novidade ? ' chm-barra-sala--tela' : ''}`} style={{ ['--cor' as string]: cor }} onClick={onAbrirReuniao} title="Abrir a reunião desta sala">
        <i className="chm-ponto" aria-hidden />
        <span className="chm-barra-texto">
          <b>{sala.nome}</b>
          <small>{novidade ?? (quadros.length === 1 ? 'Só você na chamada' : `${quadros.length} na chamada`)}</small>
        </span>
        <span className="chm-rostos" aria-hidden>
          {quadros.slice(0, 4).map((q) => (
            <Foto key={q.id} nome={q.nome} foto={q.foto} tamanho={24} />
          ))}
          {quadros.length > 4 ? <em>+{quadros.length - 4}</em> : null}
        </span>
        <span className="chm-barra-abrir">
          <i className="fas fa-expand-alt" aria-hidden /> Abrir reunião
        </span>
      </button>
      <span className="chm-barra-botoes">
        <BotoesDeMidia onMenu={setMenu} />
        <Botao ativo={ch.apresentando ? true : undefined} rotulo={ch.apresentando ? 'Parar de apresentar' : 'Apresentar a tela'} icone="fa-desktop" onClick={() => void ch.apresentar()} />
        <Botao perigo rotulo="Sair da chamada" icone="fa-phone-slash" onClick={ch.sair} />
      </span>
      <MenusDeMidia menu={menu} onFechar={() => setMenu(null)} />
    </div>
  )
}
